import axios from 'axios';

const { REACT_APP_CLIENT_ID } = process.env;


export default class UserService {
  static set setToken(token: string) {
    localStorage.setItem("token", token);
    window.dispatchEvent(new Event("auth:token"));
  }
  static set setLPC(lpc: string) {
   localStorage.setItem("lpc_data", lpc);
  }
  static set setLPCIdent(ident: string | number) {
    localStorage.setItem("lpc_calc_ident", String(ident));
  }
  static delLPCIdent() {
    localStorage.removeItem("lpc_calc_ident");
  }
  static get LPCIdent() {
    return localStorage.getItem("lpc_calc_ident");
  }
  static get LPC(): string | null {
    return localStorage.getItem("lpc_data");
  }
  static get token() {
    return localStorage.getItem("token");
  }
  static get googleClient() {
    return {
      id: REACT_APP_CLIENT_ID,
    };
  }
  static logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("lpc_calc_ident");
    localStorage.removeItem("lpc_data");
    delete axios.defaults.headers.common["Authorization"];
    window.dispatchEvent(new Event("auth:token"));
  }
  static set setLoading(value: string) {
    localStorage.setItem("loading", value);
  }
  static get loading() {
    return localStorage.getItem("loading");
  }
  static loadOut() {
    localStorage.removeItem("loading");
  }
}
